// extracted by mini-css-extract-plugin
export default {"form":"_2O8TeccHBbdT7ZRkYPHL8Y","label":"hEzu4mB5_r9bWvKixTwAg","input":"_3Vf8zdjmfy72FtACdrnaIk","errorMessage":"_1YYxQHq-zBxn3Ch5tI5kpU","required":"Be8y7_y0xC_4U5eUx2wSV"};